import { Injectable } from '@angular/core';

@Injectable()
export class Constants {
  readonly HTTP_REQUEST_RETRY_TIMES = 3;
  readonly INTERVAL_THRESHOLD_DAYS_TO_SHOW_JOB_DETAILS = 7;
  readonly DEPARTMENT_LABEL_TYPE = 'DEP';

  // APIs
  readonly ACTUATOR_INFO_ENDPOINT = '/api/actuator/info';
  readonly AGENT_USER_ENDPOINT = '/api/v1/agent';
  readonly AGENT_PASSWORD_ENDPOINT = '/api/v1/password/agent';
  readonly APP_AUTHORITY_ENDPOINT = '/api/v1/app-authority';
  readonly APP_USER_ENDPOINT = '/api/v1/app-user';
  readonly APP_USER_PASSWORD_ENDPOINT = '/api/v1/password/app-user';
  readonly CHART_SUM_CUT_CREASE_ENDPOINT = '/api/v1/graphs/sum-cut-crease';
  readonly CHART_SUM_OF_JOBS_ENDPOINT = '/api/v1/graphs/sum-jobs';
  readonly CUSTOMER_ENDPOINT = '/api/v1/customer';
  readonly DATASTATE_BY_CUSTOMER_ENDPOINT = '/api/v1/data-state/currentByCustomer';
  readonly DATAENERGY_BY_CUSTOMER_ENDPOINT = '/api/v1/data-energy/currentByCustomer';
  readonly DATAENERGY_OVERALL_CONSUMPTION_ENDPOINT = '/api/v1/data-energy/overallConsumption';
  readonly DATAENERGY_CSV_ENDPOINT = '/api/v1/data-energy/csv';
  readonly DATASTATE_ENDPOINT = '/api/v1/data-state';
  readonly DATASTATE_ERROR_RATIO_ENDPOINT = '/api/v1/data-state/error-ratio';
  readonly DATASTATE_RUNNING_RATIO_ENDPOINT = '/api/v1/data-state/running-ratio';
  readonly DATASTATE_WAIT_RATIO_ENDPOINT = '/api/v1/data-state/wait-ratio';
  readonly DATAWORKS_ENDPOINT = '/api/v1/data-work';
  readonly DATAWORKS_BY_LABEL_ENDPOINT = '/api/v1/data-work/by-label';
  readonly DATAWORKS_CSV_ENDPOINT = '/api/v1/data-work/csv';
  readonly DATAWORKS_CSV_BY_LABEL_ENDPOINT = '/api/v1/data-work/by-label/csv';
  readonly DATAWORK_BY_MACHINE_ENDPOINT = '/api/v1/data-work/jobs-by-machine';
  readonly DATAWORKS_TOTALS_ENDPOINT = '/api/v1/data-work/totals';
  readonly DATAWORKS_TOTALS_BY_LABEL_ENDPOINT = '/api/v1/data-work/by-label/totals';
  readonly FEATURE_TOGGLE_ENDPOINT = '/api/v1/feature';
  readonly LOGIN_ENDPOINT = '/api/v1/auth/login';
  readonly MACHINES_ENDPOINT = '/api/v1/machine';
  readonly JOB_ORDER_ENDPOINT = '/api/v1/job-order';
}
